import { ColumnHelper } from "@tanstack/react-table";
import { ShortlistWithScores } from "PFApp/components/resource_table_toggle/hooks/use_shortlist_items";
import { Typography } from "PFComponents/typography";

import { CustomCell } from "./custom_cell";

type CreateCustomColumnArgs = {
  id: string;
  headerLabel: string;
  getValue: (row: ShortlistWithScores) => string | undefined;
};

export const createCustomColumn = (
  columnHelper: ColumnHelper<ShortlistWithScores>,
  { id, headerLabel, getValue }: CreateCustomColumnArgs
) =>
  columnHelper.accessor((row) => row, {
    id,
    header: () => (
      <Typography withMargin variant="labelRegular">
        {headerLabel}
      </Typography>
    ),
    cell: (info) => <CustomCell value={getValue(info.getValue())} />,
    sortingFn: (rowA, rowB) => {
      const customValueA = getValue(rowA.original)?.toLowerCase() ?? "";
      const customValueB = getValue(rowB.original)?.toLowerCase() ?? "";
      return customValueA.localeCompare(customValueB);
    },
    sortUndefined: "last"
  });
